import { createAssistance } from "./create-assistance"
import { updateAssistance } from "./update-assistance"

export const assistanceService = () => {
  return {
    createAssistance,
    updateAssistance
  }
}
